import { httpRequest } from 'http'
import { calculateUnitTimers } from './helpers/unit_info'

import { sendErrorNotification } from 'helpers/web_to_client'

export const UNIT_REBUILD_INFO_REQUEST = 'unit_rebuild_info/REQUEST'
export const UNIT_REBUILD_INFO_SUCCESS = 'unit_rebuild_info/SUCCESS'
export const UNIT_REBUILD_INFO_ERROR = 'unit_rebuild_info/ERROR'
export const CLOSE_WINDOW = 'unit_rebuild_info/CLOSE_WINDOW'

export function startRequest() {
    return {
        type: UNIT_REBUILD_INFO_REQUEST,
        payload: {},
    }
}

export function requestError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: UNIT_REBUILD_INFO_ERROR,
        payload: errorData,
    }
}

export function requestSuccess(data) {

    return {
        type: UNIT_REBUILD_INFO_SUCCESS,
        payload: calculateUnitTimers(data),
    }
}

export default function requestUnitRebuildInfo(unitServerId) {
    return async (dispatch, getState) => {
        const state = getState()
        if (state.unitRebuildInfo.loading) {
            return
        }
        dispatch(startRequest())
        const url = `/game_api/units/${unitServerId}/rebuild`
        httpRequest(url)
            .then(
                resp => dispatch(requestSuccess(resp)),
                errorData => dispatch(requestError(errorData))
            )
    }
}

export function closeWindow() {
    const webToClient = {
        handler: 'closeWindow',
        params: {
            windowId: 'browser',
        },
    }
    return {
        type: CLOSE_WINDOW,
        payload: { },
        meta: { webToClient },
    }
}



// WEBPACK FOOTER //
// ./state/actions/unit_rebuild_info.js